import { Helmet } from 'react-helmet-async';
import FeatureSection from './FeatureSection';
import FeaturesBottom from './FeaturesBottom';
import FeatureHeroSection from './FeatureHeroSection';
import ContactIcon from './ContactIcon';

import main from "../feature/woo.webp";
import copykey from "../feature/copykey.webp";
import plugin from "../feature/installplugin.webp";
import pastekey from "../feature/pastekey.png";
import plugin0 from "../feature/customercapture0.webp";

function WooCommerceIntegration() {

    return ( 
        <>
            <Helmet>
                <title>Kadhr — WooCommerce Integration</title>
                <meta
                    name="description"
                    content="Connect your WooCommerce store to Kadhr in minutes. Automatically sync orders and unlock AI-powered repeat sales and customer retention."
                />
            </Helmet>

            <main className="mtopcon0 ovrflwhdn" id="up">
                <ContactIcon/>

                <div className="row">

                    {/* ========================= */}
                    {/* HERO */}
                    {/* ========================= */}
                    <FeatureHeroSection
                        title="Already selling on WooCommerce? Turn your orders into repeat revenue."
                        description="Install the Kadhr plugin, paste your API key, and your orders start syncing automatically. Kadhr takes it from there — bringing customers back at the right time."
                        image={main}
                    />

                    {/* ========================= */}
                    {/* HOW IT WORKS */}
                    {/* ========================= */}
                    <div className="col-12 text-center mt-5 pt-6indx0">

                        <FeatureSection
                            title="1. Copy your API key"
                            description="Get your unique API key from Kadhr. This securely connects your store to your Kadhr account."
                            image={copykey}
                            reverse
                        />

                        <FeatureSection
                            title="2. Install the Kadhr plugin"
                            description="Add the Kadhr plugin to your WooCommerce store like any other plugin. No coding needed."
                            image={plugin}
                        />

                        <FeatureSection
                            title="3. Paste your API key — and you're live"
                            description="Once connected, your orders automatically sync to Kadhr. No manual uploads, no extra work."
                            image={pastekey}
                            reverse
                        />

                        <FeatureSection
                            title="4. Automatic Order Sync"
                            description="Every order placed on your store is instantly available inside Kadhr — ready for analysis and action."
                            image={plugin0}
                        />

                    </div>

                    {/* ========================= */}
                    {/* CTA BLOCK */}
                    {/* ========================= */}
                    <div className="col-12 text-center mt-5 mb-5">
                        <h2 className="fw800 mb-3">
                            Start in minutes — no tech skills needed
                        </h2>
                        <p className="grey-text">
                            Install the plugin, paste your API key, and let Kadhr handle the rest.
                        </p>
                    </div>

                    <FeaturesBottom/>

                </div>
            </main>
        </>
    );
}

export default WooCommerceIntegration;